import './public-path';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@assets/css/common.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import zhCN from 'antd/es/locale/zh_CN';
import {ConfigProvider, message} from 'antd';
import "antd/dist/antd.css"
import 'moment/locale/zh-cn';
import moment from 'moment';
import store from './store';
import {Store} from 'redux';
import * as mathjs from 'mathjs';
(window as any).mathjs = mathjs; // 挂载到全局，避免库找不到

export const $store: Store = store();

moment.locale('zh-cn');
message.config({
    top: 100,
    duration: 3,
    maxCount: 1,
});


declare global {
    interface Window {
        __POWERED_BY_QIANKUN__: any
		__MIN_HEADER_WIDTH: number
    }
}

/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props: any) {
    console.log('update props', props);
}

function render(props: any) {
    const { container } = props;
    ReactDOM.render(<ConfigProvider locale={zhCN}><App store={$store} /></ConfigProvider>, container ? container.querySelector('#gtrsroot') : document.querySelector('#gtrsroot'));
}

if (!window.__POWERED_BY_QIANKUN__) {
    render({});
}

export async function bootstrap() {
    console.log('xiaoji bootstrapt', 'bootstrap');
}

export async function mount(props: any) {
    console.log('[react16] props from main framework', props);
    if (window.__POWERED_BY_QIANKUN__) {
        (window as any).callInstance = props?.callInstance?.trafficInstance;
        render(props);
    }
}

export async function unmount(props: any) {
    const { container } = props;
    ReactDOM.unmountComponentAtNode(container ? container.querySelector('#gtrsroot') : document.querySelector('#gtrsroot'));
}

// ReactDOM.render(<ConfigProvider locale={zhCN}><App store={$store} /></ConfigProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
